import { IonContent, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react';
import { ComponentProps } from 'react';

export type PageInfo = {
  endCursor: string | null;
  hasNextPage: boolean;
};

export type LoadMoreArgs = {
  variables: {
    cursor: string;
  };
};

type Props = ComponentProps<typeof IonContent> & {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  loadMore?: (args: LoadMoreArgs) => Promise<any>;
  pageInfo: PageInfo | undefined;
  skipScroll?: boolean;
};

const InfiniteScroll = ({ children, loadMore, pageInfo, skipScroll = false, ...contentProps }: Props) => {
  async function searchNext(event: CustomEvent<void>) {
    await loadMore?.({ variables: { cursor: pageInfo?.endCursor ?? '' } });

    (event.target as HTMLIonInfiniteScrollElement).complete();
  }

  if (skipScroll) {
    return <>{children}</>;
  }
  return (
    <IonContent {...contentProps}>
      {children}
      <IonInfiniteScroll
        disabled={pageInfo?.hasNextPage === false}
        onIonInfinite={async (e: CustomEvent<void>) => searchNext(e)}
        threshold="100px"
      >
        <IonInfiniteScrollContent />
      </IonInfiniteScroll>
    </IonContent>
  );
};

export default InfiniteScroll;
